import { useEffect } from 'react';
export function useImageLoad(url, onLoadCallback, onErrorCallback) {
    var image = new Image();
    useEffect(function () {
        var startTS = Date.now();
        var handleOnLoad = function (loadedEvent) {
            var perfEntry = window.performance.getEntriesByName(url, 'resource');
            if (perfEntry && perfEntry.length > 0) {
                onLoadCallback(perfEntry[0].duration, perfEntry[0].transferSize === 0, loadedEvent);
            }
            else {
                onLoadCallback(Date.now() - startTS, false, loadedEvent);
            }
        };
        var handleOnError = function (error) {
            onErrorCallback(Date.now() - startTS, error);
        };
        image.addEventListener('error', handleOnError);
        image.addEventListener('load', handleOnLoad);
        image.src = url;
        return function () {
            image.removeEventListener('load', handleOnLoad);
            image.removeEventListener('error', handleOnError);
        };
    }, [url, onLoadCallback, onErrorCallback]);
    return image;
}
//# sourceMappingURL=useImageLoad.js.map